import {
  Component,
  ElementRef,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { AbstractNgModelComponent } from 'src/app/components/base/abstract-ng-model/abstract-ng-model.component';

@Component({
  selector: 'app-issue-category2-select',
  templateUrl: './issue-category2-select.component.html',
  styleUrls: ['./issue-category2-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: IssueCategory2SelectComponent,
    },
  ],
})
export class IssueCategory2SelectComponent extends AbstractNgModelComponent {
  @ViewChild(MatMenuTrigger, { static: true, read: ElementRef })
  userMenu!: ElementRef<HTMLElement>;
  @Input() problems: any = [];

  get userMenuData() {
    return {
      menuWidth: this.userMenu.nativeElement.clientWidth,
    };
  }

  value: any;

  isDropdownOpen = false;
  src = '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';

  constructor(private elementRef: ElementRef) {
    super();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.src = '../../../../../assets/images/workorder/Icon-up-arrow-min.svg';
    } else {
      this.src =
        '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
      this.src =
        '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';
    }
  }

  override onChange(): void {
    super.onChange();
  }

  problem: any;
  selectOption(option: any) {
    this.isDropdownOpen = false;
    this.src = '../../../../../assets/images/workorder/Icon-down-arrow-min.svg';
    this.problem = option;
    this.value = this.problem.id;
    this.onChange();
  }
}
